import React, { useState, useEffect } from 'react'
import { useField } from 'formik'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import NumberFormat from 'react-number-format'

const IpsaFormattedField = ({
    label,
    prefix,
    suffix,
    thousandSeparator,
    format,
    mask,
    placeholder,
    informationText,
    showErrorMessage,
    ...props
}) => {
    const [field, meta] = useField(props)
    const [focus, setFocus] = useState(false)
    const [moveLabel, setMoveLabel] = useState(true)

    const { touched, error } = meta

    useEffect(() => {
        const { value } = meta
        const hasValue = typeof value === 'number' ? true : !!value
        setMoveLabel(hasValue || focus)
    }, [focus, meta]) // meta.value ? - gives a warning about meta not in deps list. I think this is fine

    const FocusIn = (event) => {
        event.target.select()
        setFocus(true)
    }
    const FocusOut = (event) => {
        setFocus(false)
        field.onBlur(event)
    }

    const getClassName = () => {
        let rtnClass = moveLabel ? 'move-label' : ''
        if (touched && error) {
            rtnClass = `${rtnClass} error-field`
        }
        return rtnClass
    }

    return (
        <>
            <div style={{ minWidth: '15px' }}>
                {informationText && <FontAwesomeIcon icon={faInfoCircle} title={informationText} />}
            </div>
            <div
                style={{
                    flexGrow: '1',
                }}
            >
                <NumberFormat
                    thousandSeparator={thousandSeparator}
                    prefix={prefix}
                    suffix={suffix}
                    format={format}
                    mask={mask}
                    allowNegative={false}
                    decimalScale={0}
                    {...field}
                    {...props}
                    className={getClassName()}
                    onFocus={FocusIn}
                    onBlur={FocusOut}
                    placeholder={focus && placeholder ? placeholder : ''}
                    autoComplete="off"
                ></NumberFormat>

                <label className={error && touched ? 'error' : ''} style={{ width: '100%' }}>
                    {label}
                    &nbsp;
                    {showErrorMessage && error && touched && (
                        <span className="error" style={{ float: 'right' }}>
                            {error}
                        </span>
                    )}
                </label>
            </div>
            {/* {touched && error ? <div className="error">{error}</div> : null} */}
        </>
    )
}

const IpsaMoneyField = ({ ...props }) => (
    <IpsaFormattedField prefix="$" thousandSeparator="," {...props} />
)

const IpsaPercentField = ({ ...props }) => <IpsaFormattedField suffix="%" {...props} />

const IpsaNumberField = ({ ...props }) => <IpsaFormattedField {...props} />

const IpsaDateField = ({ ...props }) => (
    <IpsaFormattedField {...props} showErrorMessage format="##-##-####" mask="_" />
)

export { IpsaMoneyField, IpsaPercentField, IpsaNumberField, IpsaDateField }
